import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, TableSortLabel, Checkbox, Box } from '@mui/material';
import ColumnFilter from './ColumnFilter';
import ResizableHeader from './ResizableHeader';

const styles = {
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
};

function Header({
  columns,
  sorts,
  setSort,
  extraColumn,
  handleSelectAllClick,
  selected,
  totalRow,
  selectedRowIds,
  expandable,
  filters,
  setFilter,
  data,
  visibleColumns,
  columnWidths,
  onColumnWidthChange
}) {
  const pageTotal = Array.isArray(data) ? data.length : 0;
  const controlledSelectedCount = Array.isArray(selectedRowIds) ? selectedRowIds.length : null;
  const checked = controlledSelectedCount !== null
    ? (controlledSelectedCount > 0 && controlledSelectedCount === totalRow)
    : (selected.length > 0 && selected.length === pageTotal);
  const indeterminate = controlledSelectedCount !== null
    ? (controlledSelectedCount > 0 && controlledSelectedCount < totalRow)
    : (selected.length > 0 && selected.length < pageTotal);

  return (
    <TableHead>
      <TableRow>
        {extraColumn && (
          <TableCell padding="checkbox" sx={{ paddingTop: 1, paddingBottom: 1 }}>
            <Checkbox
              onChange={handleSelectAllClick}
              checked={checked}
              indeterminate={indeterminate}
              size="small"
            />
          </TableCell>
        )}
        {Boolean(expandable) && <TableCell style={{ width: '50px', minWidth: '50px', maxWidth: '50px', padding: '4px' }} />}
        {columns
          .filter(col => !visibleColumns || visibleColumns.includes(col.name) || !col.name)
          .map(({ filter = true, ...row }, index) => {
          const indice = index;
          const hasName = Boolean(row.name); // Verificar si la columna tiene name
          const columnWidth = columnWidths[indice] || row.width || 150;

          return (
            <TableCell
              key={indice}
              align={row.align || 'left'}
              sortDirection={sorts && sorts[row.name] ? sorts[row.name] : false}
              style={{
                width: columnWidth,
                paddingTop: 4,
                paddingBottom: 4,
                position: 'relative',
              }}
            >
              <ResizableHeader
                columnIndex={indice}
                initialWidth={columnWidth}
                onResize={onColumnWidthChange}
                minWidth={50}
                maxWidth={500}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: 36,
                    minHeight: 36
                  }}
                >
                  {filter && hasName ? (
                    <TableSortLabel
                      active={Boolean(sorts && sorts[row.name])}
                      direction={sorts && sorts[row.name] ? sorts[row.name] : 'asc'}
                      onClick={() => setSort(row.name)}
                    >
                      {row.label}
                      {sorts && sorts[row.name] ? (
                        <span style={styles.visuallyHidden}>
                          {sorts[row.name] === 'desc' ? 'ordenar descendentemente' : 'ordenar ascendentemente'}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  ) : (
                    <strong>{row.label}</strong>
                  )}

                  {filter && hasName && (
                    <ColumnFilter
                      column={row}
                      currentFilter={filters}
                      setFilter={setFilter}
                      data={data}
                    />
                  )}
                </Box>
              </ResizableHeader>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

Header.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  sorts: PropTypes.object,
  setSort: PropTypes.func,
  extraColumn: PropTypes.bool,
  expandable: PropTypes.bool,
  handleSelectAllClick: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.array]),
  totalRow: PropTypes.number,
  selectedRowIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  filters: PropTypes.object,
  setFilter: PropTypes.func,
  data: PropTypes.array,
  visibleColumns: PropTypes.arrayOf(PropTypes.string),
  columnWidths: PropTypes.object,
  onColumnWidthChange: PropTypes.func
};

export default Header;
